import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import ProtectedRoute from '../components/auth/ProtectedRoute/ProtectedRoute';
import DashboardLayout from '../components/layout/DashboardLayout/DashboardLayout';

// Pages
import Login from '../pages/Auth/Login';
import Overview from '../pages/Dashboard/Overview';
import Conversations from '../pages/Dashboard/Conversations';
import Tenants from '../pages/Dashboard/Tenants';
import EvolutionInstances from '../pages/Dashboard/EvolutionInstances';
import WhatsAppOnboarding from '../pages/Onboarding/WhatsAppOnboarding';
import NotFound from '../pages/NotFound/NotFound';
import PrivacyPolicy from '../pages/PrivacyPolicy/PrivacyPolicy';

// Constants
import { ROUTES } from '../utils/constants';

const AppRoutes = () => {
  return (
    <Routes>
      {/* Public Routes */}
      <Route
        path={ROUTES.LOGIN}
        element={
          <ProtectedRoute requireAuth={false}>
            <Login />
          </ProtectedRoute>
        }
      />

      {/* WhatsApp Onboarding - Public/Protected based on your needs */}
      <Route path="/onboarding/whatsapp" element={<WhatsAppOnboarding />} />

      {/* Privacy Policy - Public */}
      <Route path="/privacidade" element={<PrivacyPolicy />} />
      <Route path="/privacy-policy" element={<PrivacyPolicy />} />

      {/* Protected Routes - Dashboard */}
      <Route
        path={ROUTES.DASHBOARD}
        element={
          <ProtectedRoute requireAuth={true}>
            <DashboardLayout />
          </ProtectedRoute>
        }
      >
        {/* Redirect /dashboard to /dashboard/conversations */}
        <Route index element={<Navigate to={ROUTES.CONVERSATIONS} replace />} />
        
        <Route path="overview" element={<Overview />} />
        <Route path="conversations" element={<Conversations />} />
        <Route path="tenants" element={<Tenants />} />
        <Route path="evolution" element={<EvolutionInstances />} />
        
        {/* Adicione mais rotas do dashboard aqui */}
        {/* <Route path="reports" element={<Reports />} /> */}
        {/* <Route path="settings" element={<Settings />} /> */}
      </Route>

      {/* Root redirect */}
      <Route path="/" element={<Navigate to={ROUTES.DASHBOARD} replace />} />

      {/* 404 - Not Found */}
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
};

export default AppRoutes;